import { render, staticRenderFns } from "./SamplesCol.vue?vue&type=template&id=05b33f78&"
import script from "./SamplesCol.vue?vue&type=script&lang=js&"
export * from "./SamplesCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports